import {APIManager} from "shared/manager";
import {RestEnds} from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

const saveLoan = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.LOANS}/${loanId}/save-loan`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const checkABN = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.VERIFY_ABN}`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const saveBusiness = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.LOANS}/${loanId}/save-business`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const saveRNDBusiness = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.RND_LOANS}/${loanId}/save-business`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const getLoanReview = async (loanId) => {
  return APIManager.sendGet(
    `${RestEnds.LOANS}/${loanId}/review-details`,
    AxiosManager,
    true,
    {},
    {},
  );
};

const calculateEligibleLoan = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.CALCULATE_ELIGIBLE_LOAN}`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const initiateKYC = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.INITIATE_KYC}`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const initiateKYCMultiple = async (loanId) => {
  return APIManager.sendPatch(
    `${RestEnds.INITIATE_KYC_MULTIPLE}/${loanId}`,
    AxiosManager,
    {},
    true,
    {},
    {},
  );
};

const addBankDetails = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.BANK_DETAILS}/${loanId}/add`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const addSolicitorDetails = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.SOLICITOR_DETAILS}/${loanId}/add`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const uploadLoanDocument = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RestEnds.UPLOAD_DOCUMENT,
    AxiosManager,
    data,
    true,
    {},
    {},
  );

const getAllMappedDocuments = async (offset, limit, loanId) => {
  return APIManager.sendGet(
    `${RestEnds.DOCUMENTS}?offset=${offset}&limit=${limit}&loanId=${loanId}`,
    AxiosManager,
    true,
    {},
    {},
  );
};

const getKYCVerificationStatus = async (loanId, kycId): Promise<any> =>
  APIManager.sendGet(
    RestEnds.KYC_STATUS(loanId, kycId),
    AxiosManager,
    true,
    {},
    {},
  );

const resendKYC = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.RESEND_KYC, AxiosManager, data, true, {}, {});

const generateDocumentMapping = async (data): Promise<any> =>
  APIManager.sendPost(
    RestEnds.GENERATE_MAPPING_DOCUMENTS,
    AxiosManager,
    data,
    true,
    {},
    {},
  );

const downloadSignedDocuments = async (data): Promise<any> =>
  APIManager.sendPatch(
    RestEnds.DOWNLOAD_SIGNED_DOCUMENT,
    AxiosManager,
    data,
    true,
    {},
    {},
  );

const getSignersList = async (
  offset: any,
  limit: any,
  loanId: string,
): Promise<any> =>
  APIManager.sendGet(
    RestEnds.SIGNERS_LIST(offset, limit, loanId),
    AxiosManager,
    true,
    {},
    {},
  );

const requestCallBack = async (loanId: string): Promise<any> =>
  APIManager.sendPatch(
    `${RestEnds.REQUEST_CALL_BACK}/${loanId}`,
    AxiosManager,
    {},
    true,
    {},
    {},
  );

const updateDocumentMailedStatus = async (
  loanId: string,
  loanDocumentId: string,
  data: any,
): Promise<any> =>
  APIManager.sendPatch(
    `${RestEnds.MAILED_DOCUMENTS}/${loanId}/${loanDocumentId}`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );

// ----------- RND
const getRNDLoanReview = async (loanId) => {
  return APIManager.sendGet(
    `${RestEnds.RND_LOANS}/${loanId}/review-details`,
    AxiosManager,
    true,
    {},
    {},
  );
};

const saveRNDLoan = async (data, loanId) => {
  return APIManager.sendPost(
    `${RestEnds.RND_LOANS}/${loanId}/save-loan`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

const rndLoanCalculator = async (data: any) => {
  return APIManager.sendPost(
    `${RestEnds.RND_LOAN_CALCULATOR}`,
    AxiosManager,
    data,
    true,
    {},
    {},
  );
};

export const LoanService = {
  saveLoan,
  checkABN,
  saveBusiness,
  getLoanReview,
  calculateEligibleLoan,
  initiateKYC,
  addBankDetails,
  addSolicitorDetails,
  getAllMappedDocuments,
  getKYCVerificationStatus,
  uploadLoanDocument,
  resendKYC,
  generateDocumentMapping,
  downloadSignedDocuments,
  getSignersList,
  requestCallBack,
  updateDocumentMailedStatus,
  initiateKYCMultiple,
  // RND
  getRNDLoanReview,
  saveRNDLoan,
  saveRNDBusiness,
  rndLoanCalculator,
};
